import { ReactNode, useEffect, useState } from "react";
import { ThemeProvider } from "react-jss";
import { DefaultTheme } from "../../../constants/theme";
import { getMediaSizeScale } from "../../../models/screen";

export function ScaledThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setTheme] = useState(() => ({ ...DefaultTheme }));

  useEffect(() => {
    let lastScale = getMediaSizeScale();

    // New reference → react-jss rebuilds all sheets, re-running plugins.
    const applyScale = () => {
      const nextScale = getMediaSizeScale();
      if (nextScale === lastScale) return;
      lastScale = nextScale;
      setTheme({ ...DefaultTheme });
    };

    window.addEventListener("resize", applyScale);
    return () => {
      window.removeEventListener("resize", applyScale);
    };
  }, []);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
